export class MediaServerValidationRequest {
  url: string;
  fileName: string;

  constructor(init: any) {
    this.url = init.url;
    this.fileName = init.fileName;
  }
}
